module.exports = __webpack_public_path__ + "static/media/biorific-shot.b5573f31.jpg";